import { useTranslationWithNamespace } from '@gov-nx/core/service';
import {
	useMojeSouboryNahratContext,
	useMojeSouborySeznamContext,
} from '@gov-nx/module/page';
import { Button, Icon, LayoutGap } from '@gov-nx/ui/web';
import { Storage } from './Storage';
import { useExtraConfigContext } from '@gov-nx/core/app';

export const UploadSection = () => {
	const { code } = useMojeSouborySeznamContext();
	const { isUploadModalOpened } = useMojeSouboryNahratContext();
	const { getLocalizeCurried } = useTranslationWithNamespace();
	const tsn = getLocalizeCurried(code);
	const {
		extraConfig: {
			pageRoutes: {
				myFilesConfig: { isUploadAllowed },
			},
		},
	} = useExtraConfigContext();

	return (
		<LayoutGap gap="m">
			<Storage />
			{isUploadAllowed && (
				<Button
					aria-label={tsn('akce.nahrat-soubor')}
					color="primary"
					type="solid"
					size="m"
					isExpandedMobile
					onClick={isUploadModalOpened.setTrue}
					iconStart={
						<Icon
							name="upload"
							type="components"
						/>
					}>
					{tsn('akce.nahrat-soubor')}
				</Button>
			)}
		</LayoutGap>
	);
};
